<script lang="ts">
  import { Icon } from '@smui/icon-button';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
  const onClick = (e) => {
    dispatch('click', e);
  };
</script>

<button
  on:click={onClick}
  class="icon-button d-flex justify-content-center align-items-center"
>
  <Icon style="font-size:1rem;" class="material-icons">add</Icon>
</button>

<style>
  .icon-button {
    background-color: #ddd;
    color: #555;
    border: none;
    border-radius: 1rem;
  }
</style>
